import { useIntl } from "../../../_metronic/i18n/customUseIntl";
import { CoreConnectCompoundFeedNameDatabase } from "../components/FarmFlow/Baseline/types";

export const getFeedsLoadingPlaceholder = (selectedDatabaseFoundation: string) => {
  const intl = useIntl();
  return {
    display_name: intl.formatMessage({
      id: "COMPOUNDFEEDS.LOADING",
    }),
    value: "loading",
    databaseFoundation: selectedDatabaseFoundation,
  } as CoreConnectCompoundFeedNameDatabase;
};
